import * as React from "react";
const SvgFiRrFlashlight = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-flashlight_svg__a)">
      <path
        fill="#062147"
        d="M23.405 8.289 15.712.596a2.02 2.02 0 0 0-2.931.073c-1.742 1.954-2.782 4.558-2.782 6.965v.873l-8.861 8.86A3.86 3.86 0 0 0 0 20.116c0 1.037.404 2.014 1.138 2.747a3.87 3.87 0 0 0 2.748 1.137c.996 0 1.989-.38 2.747-1.136L15.495 14h.872c2.407 0 5.011-1.04 6.966-2.781A2 2 0 0 0 24 9.783a2.04 2.04 0 0 0-.595-1.494M5.218 21.449a1.89 1.89 0 0 1-2.666 0A1.87 1.87 0 0 1 2 20.116c0-.504.196-.977.552-1.333l8.444-8.443 2.666 2.666zM16.366 12h-.881l-3.486-3.486v-.881c0-1.93.851-4.036 2.298-5.624l7.694 7.693.01.023C20.403 11.15 18.296 12 16.366 12m-5.66 2.707-1 1a.997.997 0 0 1-1.414 0 1 1 0 0 1 0-1.414l1-1a.999.999 0 1 1 1.414 1.414"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-flashlight_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrFlashlight;
